import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import { AuthService } from '../../auth/auth.service';
import { Observable } from 'rxjs';
import { PromoRequest, PromoResponse} from '@builtbybros/al-model';
import {environment} from '../../../environments/environment';

@Injectable()
export class PromoService {

  promoUrl = '/Promo';
  promoItemUrl = '/PromoItem';

  constructor(    private http: Http,
                  private authService: AuthService) { }


  createPromo( promoRequest: PromoRequest.Create ): Observable< PromoResponse.Promo > {

    const options = this.authService.addAuthToken();

    return this.http.post(environment.alApiUrl + this.promoUrl, promoRequest, options)
      .map((res) => {
        const json = res.json();
        const promoResponse = new PromoResponse.Promo();
        return promoResponse.parse(json);
      });
      // TODO: Catch error.
  }

  getPromo(id: number): Observable<PromoResponse.Promo> {
    const options = this.authService.addAuthToken();

    return this.http
      .get(environment.alApiUrl + this.promoUrl + '/' + id, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
      // TODO: Catch error.
  }

  getAllPromos(): Observable<PromoResponse.All> {
    return this.http
      .get(`${environment.alApiUrl}${this.promoUrl}/All`)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
  }

  updatePromo( id: number, promoRequest: PromoRequest.Update ): Observable< PromoResponse.Promo > {

    const options = this.authService.addAuthToken();
    const url = environment.alApiUrl + this.promoUrl + '/' + id;
    return this.http.patch(url, promoRequest, options)
      .map((res) => {
        const json = res.json();
        const promoResponse = new PromoResponse.Promo();
        return promoResponse.parse(json);
      });
    // TODO: Catch error.
  }

  deletePromo(id: number): Observable<number> {
    const options = this.authService.addAuthToken();
    return this.http
      .delete(`${environment.alApiUrl}${this.promoUrl}/${id}`, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
  }

  assignPromoItems(id: number, promoAssign: PromoRequest.Assign) {
    const options = this.authService.addAuthToken();
    const url = environment.alApiUrl + this.promoItemUrl + '/' + id;
    return this.http.patch(url, promoAssign, options)
      .map((res) => {
        const json = res.json();
        return 1;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/promos/shared/promo.service.ts